import React, {Component} from 'react';
import QueryString from 'query-string';
import LocationListener from "../../common/LocationListener";
import history from '../../history';
import PropTypes from 'prop-types';
import {getSetting} from "../../common/LocalSettings/LocalSettings";


/**
 * Appends query string to location/url
 * @param url
 * @param query
 */
export function joinQuery(url,query) {

    if(query){

        if(url.indexOf("?") >= 0)
            return `${url}&${query}`;

        return `${url.replace(/[/]$/,  "")}?${query}`;
    }

    return url;
}

/**
 * Creates a filter state object from parts
 * @param parts
 */
export function createFilter(parts) {

    let state = {};
    let _v;
    Object.keys(parts).forEach(item =>{
        _v = parts[item];
        if(!(_v === undefined || _v === null)){
            state[item] = parts[item];
        }
    });

    return state;
}

/**
 * Creates a query string from parts
 * @param parts
 * @return {string}
 */
export function createQuery(parts) {

    let  _result = [];
    let _v;
    Object.keys(parts).forEach(item => {
        _v = parts[item];
        if(_v !== undefined && _v !== null && _v !== ''){
            _result.push(`${item}=${encodeURIComponent(parts[item])}`);
        }
    });

    return _result.join("&");
}

/*
const fs = [
    {
        key: 'licenseFilter',
        query: 'lcs', // query key
        toQuery: '', // to query string
        fromQuery: '', // from query string
        name: 'License'
    }
];
*/

const SearchFilterInfo = {
    key: 'search',
    name: 'Search',
    query: 'q'
};

const PageFilterInfo = {
    key: 'page',
    query: 'page',
    fromQuery: (value,query) => isFinite(value) ? Number(value) : undefined,
    toQuery: (value,filter) => isFinite(value) ? Number(value) : undefined , // to query string
};

const LimitFilterInfo = {
    key: 'itemsPerPage',
    query: 'limit',
    fromQuery: (value,query) => isFinite(value) ? Number(value) : undefined,
    toQuery: (value,filter) => isFinite(value) ? Number(value) : undefined , // to query string
};

class FilterQueryWrapper extends  Component{

    static propTypes = {
        filters: PropTypes.array,
        defaultFilters: PropTypes.array,
        onFilterToQuery: PropTypes.func,
        onQueryToFilter: PropTypes.func,
        enableSearch: PropTypes.bool,
        initialPage: PropTypes.number,
        initialItemsPerPage: PropTypes.number,
        onFilterParsed: PropTypes.func,
        children: PropTypes.any,
        onChange: PropTypes.func,
        handleLocationChange: PropTypes.func,
        block: PropTypes.func
    };

    static defaultProps = {
        initialPage: 1
    };

    constructor(props){
        super(props);

        //
        let _defaultFilters = props.defaultFilters;
        const _filterConfiguration = Array.isArray(_defaultFilters) ? _defaultFilters.concat(props.filters || []) : (props.filters || []);
        if(props.enableSearch){
            _filterConfiguration.push(SearchFilterInfo);
        }

        //  Append pagination filter handlers
        _filterConfiguration.push(PageFilterInfo);
        _filterConfiguration.push(LimitFilterInfo);

        //
        const _filters = this.onParseFilters({
            ...QueryString.parse(history.location.search)
        }, _filterConfiguration );

        //
        if(!_filters.hasOwnProperty(PageFilterInfo.key) || !isFinite(_filters.page))
            _filters[PageFilterInfo.key] = props.initialPage;

        if(!_filters.hasOwnProperty(LimitFilterInfo.key) || !isFinite(_filters.itemsPerPage))
            _filters[LimitFilterInfo.key] = props.initialItemsPerPage || Number(getSetting('items_per_page',10));

        this.state = {
            filters: _filters,
            filterConfiguration: _filterConfiguration,
        };

        //
        this.updateFilters = this.updateFilters.bind(this);
        this.onApplyFilters = this.onApplyFilters.bind(this);
        this._handleLocationChange = this._handleLocationChange.bind(this);

        //  refresh state
        this._isMounted = false;
    }

    setStateSafe(state,callback){

        if(this._isMounted){
            this.setState(state,callback);
        }

    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    /**
     * Convert query string to filters
     * @param query {Object} The query string to be parsed
     * @param filterConfiguration Filter configuration state
     * @return {Object}
     */
    onParseFilters(query , filterConfiguration){

        const finalize = (filter) => {

            if(this.props.onFilterParsed)
                this.props.onFilterParsed(filter);

            return filter;
        };

        filterConfiguration = filterConfiguration || this.state.filterConfiguration;
        if(this.props.onQueryToFilter)
            return finalize( this.props.onQueryToFilter(query,filterConfiguration) );

        let _fs = { };
        for(let i = 0; i < filterConfiguration.length; i++){
            const f = filterConfiguration[i];
            _fs[f.key] = f.hasOwnProperty('fromQuery') ? f.fromQuery(query[f.query || f.key],query) : query[f.query || f.key];
        }

        return finalize(createFilter(_fs));
    }

    /**
     * Convert filter state object to query
     * @param filters {Object} The filter state object
     * @param filterConfiguration Filter configuration state
     * @return {string}
     */
    filterToQuery(filters, filterConfiguration){

        filterConfiguration = filterConfiguration || this.state.filterConfiguration;

        if(this.props.onFilterToQuery)
            return (this.props.onFilterToQuery(filters,filterConfiguration));

        let _fs = { };
        for(let i = 0; i < filterConfiguration.length; i++){
            const f = filterConfiguration[i];
            _fs[f.query || f.key] = f.hasOwnProperty('toQuery') ? f.toQuery(filters[f.key],filters) : filters[f.key];
        }

        return (createQuery(_fs));
    }

    _handleFilterChanged(){

        //  Invoke onChange...
        if(this.props.onChange)
            this.props.onChange(this.getFilters());

    }

    /**
     * Updates filter state and refreshes view
     * @param filters
     */
    updateFilters(filters){

        if(!this._isMounted)
            return;

        this.setStateSafe({
            filters
        }, () => {
            this._handleFilterChanged();
        });
    }

    setFiltersRaw(callback , apply = true){

        const _filters =  callback(this.state.filters);

        this.setStateSafe({
            filters: _filters
        }, () => {

            if(apply){
                this.onApplyFilters(_filters);
            }
        })

    }

    hasFilters(exclude = []){
        const _keys = Object.keys(this.state.filters);
        return _keys.length > 0 && _keys.find(x => !exclude.includes(x));
    }

    getFilters(){

        const { filters: { page , itemsPerPage , ...otherFilters } }  = this.state;
        const props = this.props;

        return {
            filters: otherFilters,
            page: isFinite(page) ?  Number(page) : props.initialPage,
            limit: isFinite(itemsPerPage) ? Number(itemsPerPage) : props.initialItemsPerPage
        }
    }

    /**
     * Applies fields to the query which would trigger update in state
     * @param filter Filter object
     * @param refreshList Set to true to refresh list after updating query filters
     */
    onApplyFilters(filter , refreshList = true){

        //  set refresh parameter
        this.refreshOnLocationUpdate = refreshList;

        history.push(joinQuery(history.location.pathname, this.filterToQuery({
            ...this.state.filters,
            ...filter
        })));

    }

    getFilterValue(key,defaultValue = undefined){

        if(this.state.filters.hasOwnProperty(key)){
            return this.state.filters[key];
        }

        return defaultValue;
    }

    componentDidMount(){

        //
        this._isMounted = true;

        let currentPage = Number(this.state.filters.page);
        let pageLimit = Number(this.state.filters.itemsPerPage);

        let _page = (currentPage < 1) ? this.props.initialPage : currentPage;
        let _limit = (pageLimit <= 0) ? this.props.initialItemsPerPage : pageLimit;

        //  ----------------------------------------------------------
        //  Ensure Pagination Is Valid
        //  ----------------------------------------------------------
        if(isFinite(_limit) || isFinite(_page)){

            this.setStateSafe({

                filters: {
                    ...this.state.filters,
                    page: _page,
                    itemsPerPage: _limit
                }

            }, () => {
                this._handleFilterChanged();
            });


        }
    }

    _handleLocationChange(location){

        //
        this.updateFilters(this.onParseFilters({
            ...QueryString.parse(location.search)
        }));

        //  relay location changed
        if(this.props.handleLocationChange) {
            this.props.handleLocationChange(location);
        }

    }


    /**
     * Render view
     */
    render(){

        const { children , block } = this.props;
        return <LocationListener block={block} onChange={this._handleLocationChange}>
            {children}
        </LocationListener>;

    }

}

export default FilterQueryWrapper;



// WEBPACK FOOTER //
// ./src/components/FilterQueryWrapper/FilterQueryWrapper.js